import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Button, Flex, Tooltip } from 'antd';
import balloonImage1 from '../../images/blue_baloon.png';
import balloonImage2 from '../../images/green_baloon.png';
import balloonImage3 from '../../images/purple_baloon.png';
import '../../styles/style.css';
const RegulationsKPIPanel = ({ data, handleKPIOnClick }) => {
    // Array of balloon images
    const balloonImages = [balloonImage1, balloonImage2, balloonImage3];
    const [width, setWidth] = useState(window.innerWidth);
    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }
    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        };
    }, []);
    return (_jsx(Flex, { gap: "middle", justify: "space-around", align: "center", wrap: "wrap", children: data === null || data === void 0 ? void 0 : data.map((item, index) => {
            // Cycle through images using modulo to repeat
            const imageIndex = index % balloonImages.length;
            return (_jsxs("div", { style: { display: 'flex', alignItems: 'center', gap: width <= 420 ? '2px' : '8px' }, children: [_jsx(Tooltip, { title: item === null || item === void 0 ? void 0 : item.strLongDesc, placement: "top", children: _jsx(Button, { disabled: (item === null || item === void 0 ? void 0 : item.intStatusCount) <= 0, onClick: () => handleKPIOnClick(item === null || item === void 0 ? void 0 : item.intId), className: `animated-button ${(item === null || item === void 0 ? void 0 : item.intStatusCount) > 0 ? 'active' : ''}`, style: {
                                backgroundImage: `url(${balloonImages[imageIndex]})`,
                                backgroundSize: 'contain',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'center',
                                width: width <= 420 ? 30 : 60,
                                height: width <= 420 ? 30 : 60,
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                border: 'none',
                                padding: 0,
                                backgroundColor: 'transparent'
                            }, children: _jsx("span", { style: {
                                    color: 'white',
                                    fontWeight: 'bold',
                                    fontSize: width <= 420 ? '14px' : '18px',
                                    textShadow: '1px 1px 2px rgba(0, 0, 0, 0.5)',
                                    marginBottom: '7px'
                                }, children: item === null || item === void 0 ? void 0 : item.intStatusCount }) }, `${item === null || item === void 0 ? void 0 : item.intId}_kpi_button`) }, `${item === null || item === void 0 ? void 0 : item.intId}_kpi_tooltip`), _jsx("span", { style: { fontSize: '15px', color: '#333', fontWeight: 'normal' }, children: item === null || item === void 0 ? void 0 : item.strLongDesc }, `${item === null || item === void 0 ? void 0 : item.intId}_kpi_span`)] }, `${item === null || item === void 0 ? void 0 : item.intId}_kpi_div`));
        }) }));
};
export default RegulationsKPIPanel;
